import { GeneralSettingsService } from "./generalSettings";
import { AxiosResponse } from 'axios';
import { Webhook } from "src/types/webhook";

export interface ApiGeneralSettings {
    getWebhooks(): Promise<AxiosResponse>;
    updateWebhooks(webhooks:Webhook[]): Promise<AxiosResponse>;
}

export const generalSettingsService = new GeneralSettingsService();